import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";

const ContainerTypesSelect = (
    {
        prefix = "", multiple = false,
        disabled = false,
        onChange,
        value,
        defaultValue
    }
) => {
    const {t: _Tc} = useTranslation("choices");
    const selectProps = {};

    if (value !== undefined) {
        selectProps.value = value;
    } else if (defaultValue !== undefined) {
        selectProps.defaultValue = defaultValue;
    } else {
        selectProps.defaultValue = "";
    }
    if (onChange !== undefined) {
        selectProps.onChange = onChange;
    }
    return (
        <Form.Select
            aria-label="Selector de tipo de contenedor"
            name={prefix + "container_type"}
            disabled={disabled}
            {...selectProps}
        >
            <option value="">{_Tc("devices.all")}</option>
            <option value="su">{_Tc("containers.su")}</option>
            <option value="un">{_Tc("containers.un")}</option>
        </Form.Select>
    )

}
export default ContainerTypesSelect